import angular from 'angular';

import '../../../../services/mailchimp';

angular.module('folkeuni').component('checkoutNewsletter', {
    bindings: {
        cart: '=',
        siteId: '=',
        signUpForNewsletter: '=',
    },
    controller: function (Mailchimp) {
        var $ctrl = this;
        $ctrl.loading = false;

        $ctrl.$onInit = function () {
            var areas = [];

            for (var i = 0; $ctrl.cart.products.length > i; i++) {
                var currentOrderline = $ctrl.cart.products[i];

                if (areas.indexOf(currentOrderline.areaId) == -1) {
                    areas.push(currentOrderline.areaId);
                }
            }

            
            Mailchimp.categoriesGetBySiteId($ctrl.siteId, $ctrl.cart.checkout.customer.email).then(
                function (categories) {
                    $ctrl.cart.newsletter = categories;

                    //if ($ctrl.siteId == 1) { // Aarhus     
                    //    $ctrl.cart.newsletter[0].options[0].selected = areas.indexOf(1) > -1;
                    //    $ctrl.cart.newsletter[0].options[1].selected = areas.indexOf(2) > -1;
                    //    $ctrl.cart.newsletter[0].options[2].selected = areas.indexOf(3) > -1;
                    //} else if ($ctrl.siteId == 3) { // Odense
                    //    $ctrl.cart.newsletter[0].options[0].selected = areas.indexOf(4) > -1;
                    //    $ctrl.cart.newsletter[0].options[1].selected = areas.indexOf(5) > -1;
                    //    //  $ctrl.cart.newsletter[0].options[2].selected = areas.includes(6);
                    //} else if ($ctrl.siteId == 15) { // Aalborg

                    //}
                });
        };

    },
    templateUrl: '/shop-dist/templates/checkout-newsletter.html?c=' + window.cacheBurst,
    transclude: true
});
